module.exports = __webpack_public_path__ + "img/schedule.30714746.png";